module.exports = __webpack_public_path__ + "static/media/SPRING_WHEAT_1x.d4445434.png";